import {
  QueryClientProvider,
  QueryErrorResetBoundary,
} from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { App as AntdApp, ConfigProvider } from 'antd';
import locale from 'antd/locale/pt_BR';
import 'dayjs/locale/pt-br';

import { Suspense } from 'react';

import { ErrorBoundary } from 'react-error-boundary';

import InternalErrorBoundary from '@components/internal-error-boundary';
import PageLoading from '@components/page-loading';
import { captureFrontendException } from '@lib/observability/sentry';

import { useAppTheme } from '../../config/theme/provider';

import CartProvider from '../../lib/providers/cart-provider';
import { queryClient } from '../../lib/query-client';
import { router } from '../../lib/router';

const AppContent = () => {
  const { theme } = useAppTheme();

  return (
    <ConfigProvider theme={theme} locale={locale}>
      <AntdApp>
        <QueryClientProvider client={queryClient}>
          <QueryErrorResetBoundary>
            {({ reset }) => (
              <ErrorBoundary
                FallbackComponent={InternalErrorBoundary}
                onError={(error, info) => {
                  captureFrontendException(error, {
                    componentStack: info.componentStack,
                  });
                }}
                onReset={() => {
                  reset();
                }}
              >
                <CartProvider>
                  <Suspense fallback={<PageLoading />}>
                    <RouterProvider router={router} context={{ queryClient }} />
                  </Suspense>
                </CartProvider>
              </ErrorBoundary>
            )}
          </QueryErrorResetBoundary>
        </QueryClientProvider>
      </AntdApp>
    </ConfigProvider>
  );
};

export default AppContent;
